var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_21111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.08005 0.234844C5.08005 0.234844 5.06005 0.234844 5.05005 0.214844V11.6448L9.04005 13.7648C9.04005 13.7648 9.07005 13.7748 9.09005 13.7848V2.37484L5.08005 0.234844Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00999 0.215078L0.50999 2.35508C0.18999 2.53508 -0.0100098 2.88508 -0.0100098 3.25508V12.5751C-0.0100098 12.9551 0.18999 13.2951 0.51999 13.4751C0.84999 13.6551 1.24999 13.6451 1.57999 13.4351L4.03999 11.7851V0.205078C4.03999 0.205078 4.01999 0.205078 3.99999 0.215078H4.00999Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4801 0.555044C13.1501 0.375044 12.7501 0.385044 12.4101 0.605044L10.0801 2.23504V13.795C10.0801 13.795 10.1301 13.775 10.1501 13.765L13.5301 11.375C13.8301 11.185 14.0101 10.855 14.0101 10.505V1.45504C14.0101 1.07504 13.8101 0.735044 13.4801 0.555044Z",
    fill: "#CDCED7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_21111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.02,
    height: 13.59,
    fill: "white",
    transform: "translate(-0.0100098 0.205078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMap);
export default __webpack_public_path__ + "static/media/home_map.5cf05413d60c50aa96a8184b367c3477.svg";
export { ForwardRef as ReactComponent };